import type {
  ContactPageData,
  ContactPageResponse,
} from '../types/contact-page';

export const ContactPageFallbackData: ContactPageData = {
  id: 1,
  documentId: 'dcvsqkc91aphhxif0hn5824v',
  mapUrl:
    'https://maps.google.com/maps?q=Trung+T%C3%A2m+H%E1%BB%99i+Ngh%E1%BB%8B+Ti%E1%BB%87c+C%C6%B0%E1%BB%9Bi+Sen+H%E1%BB%93ng',
  createdAt: '2025-08-20T04:24:35.030Z',
  updatedAt: '2025-08-20T04:24:35.037Z',
  publishedAt: null,
  locale: null,
  seo: {
    id: 7,
    metaTitle: 'Liên hệ - Bách Việt',
    metaDescription:
      'Liên hệ với Công ty TNHH Sản xuất và Thương mại Hàng cơ khí Bách Việt. Địa chỉ, điện thoại, email và bản đồ.',
    keywords: 'liên hệ, bách việt, cơ khí, hà nội, thanh oai',
  },
  hero: {
    id: 6,
    title: 'LIÊN HỆ',
    content: null,
  },
  contactInfo: {
    id: 2,
    address:
      'Trụ sở: Thôn Rùa Thượng, Xã Thanh Thùy, Huyện Thanh Oai, Thành phố Hà Nội, Việt Nam',
    phone: '0983973023',
    email: 'contact@bachviet.com.vn',
  },
};

export const ContactPageFallbackResponse: ContactPageResponse = {
  data: ContactPageFallbackData,
  meta: {
    pagination: {
      page: 1,
      pageSize: 9,
      pageCount: 1,
      total: 6,
    },
  },
};
